import React, { useState } from 'react';
import { FaHome, FaUserCircle } from 'react-icons/fa';
import './header.css';
import logo from "../../assests/app_logo.png";
import { useNavigate } from 'react-router-dom';

const CustomHeader = ({ onBack, heading, extraComp, hideHome = false, headingComp, secondaryHeading, onFilterToggle, showFilter, viewText, onViewToggle, extraMenuItem, onExtraItemClick }) => {
    const [showMenu, setShowMenu] = useState(false);
    const navigate = useNavigate();


    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("current_fm_id");
        localStorage.removeItem("first_visit");
        localStorage.removeItem("user_data");
        navigate("/");
        setShowMenu(false);
    };

    const handleBack = () => {
        if (onBack) {
            onBack?.();
            return
        }
        navigate(-1);
    };

    return (
        <header className="custom-header">
            <div className="custom-header-left">
                {!hideHome &&
                    <button onClick={handleBack} type='button' className="custom-back-button">
                        <FaHome /> Home
                    </button>
                }
                <img src={logo} alt="Logo" className="custom-logo" />
                {secondaryHeading && <div style={{ marginLeft: 10, fontSize: 20, color: '#056c5f', fontWeight: 'bold', marginTop: 5, }}>{secondaryHeading}</div>}
            </div>

            {heading && <h1 style={{ color: '#926429', fontSize: 25, textDecorationLine: 'underline' }} className="custom-header-title">{heading}</h1>}
            {headingComp}

            <div className="custom-header-right">
                {extraComp}
                <FaUserCircle
                    className="custom-profile-icon"
                    onClick={() => setShowMenu(!showMenu)}
                />
                {showMenu && (
                    <div className="custom-dropdown-menu">
                        {extraMenuItem &&
                            <button
                                onClick={() => {
                                    setShowMenu(!showMenu)
                                    onExtraItemClick?.()
                                }}>
                                {extraMenuItem}
                            </button>
                        }
                        {showFilter &&
                            <button
                                onClick={() => {
                                    setShowMenu(!showMenu)
                                    onFilterToggle?.()
                                }}>
                                Date Filter
                            </button>
                        }
                        {viewText &&
                            <button
                                onClick={() => {
                                    setShowMenu(!showMenu)
                                    onViewToggle?.()
                                }}>
                                {viewText}
                            </button>
                        }
                        <button onClick={handleLogout}>Logout</button>
                    </div>
                )}
            </div>
        </header>
    );
};

export default CustomHeader;
